import { CoinFeatureCategories } from '@xylabs/sdk-coin-js';
const coinFeatureCategories = [];
for (const category in CoinFeatureCategories) {
    coinFeatureCategories.push(category);
}
export default coinFeatureCategories;
//# sourceMappingURL=coinFeatureCategories.js.map